document.addEventListener('DOMContentLoaded', function () {
  // Select all toggle headings in the mobile footer
  const toggleHeadings = document.querySelectorAll(
    '.mobilefooter .footer-toggle-heading, .mobilefooter .firsttitle, .mobilefooter .footertitlepolicy'
  );

  toggleHeadings.forEach((heading) => {
    heading.addEventListener('click', function () {
      // Get the parent footer-block and the associated content
      const parentBlock = this.closest('.footer-block');
      const content = parentBlock.querySelector(
        '.footercontenthide, .footercontentfirsthide, .footercontentpolicyhide'
      );

      // Check if the clicked section is already active
      const isActive = this.classList.contains('active');

      // Close all sections
      toggleHeadings.forEach((otherHeading) => {
        const otherParentBlock = otherHeading.closest('.footer-block');
        const otherContent = otherParentBlock.querySelector(
          '.footercontenthide, .footercontentfirsthide, .footercontentpolicyhide'
        );
        otherHeading.classList.remove('active');
        otherHeading.setAttribute('aria-expanded', 'false');
        if (otherContent) {
          otherContent.classList.remove('active');
        }
      });

      // Toggle the clicked section
      if (!isActive) {
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        if (content) {
          content.classList.add('active');
        }
      }
    });
  });
});